




















import Vue from "vue";
import {PythonShell} from 'python-shell';
import AppDialog from "~/components/AppDialog.vue";
import {
  AnonymizationConfig,
  AnonymizationConfigInputValue,
  AnonymizationConfigItem,
} from "@qurit/anonymizer";

export default Vue.extend({
  components: {
    AppDialog
  },
  props: ['existingConfigNames'],
  data: () => ({
      name: '',
      file: null as null | File,
      configData: [] as AnonymizationConfigItem[],
      constants: [] as AnonymizationConfigInputValue[],
      variables: [] as AnonymizationConfigInputValue[],
  }),
  methods: {
    async handleJSONUpload(file: File) {
      try {
        const importedConfig = await this.readJSON(file) as AnonymizationConfig;
        this.configData = importedConfig.configData || [];
        this.constants = importedConfig.constants || [];
        this.variables = importedConfig.variables || [];
      } catch (e) {
        this.$toast.error(`Failed to import from JSON: ${e.message}`);
        this.file = null;
      }
    },
    // async handleDotScriptUpload(file: File) {
    //   let options: {
    //     mode: 'json',
    //     pythonPath: 'path/to/python',
    //     pythonOptions: ['-u'], // get print results in real-time
    //     scriptPath: '../../scripts',
    //     args: ['./tag-list-data/dicom-anonymizer.script']
    //   };
    //   try {
    //     PythonShell.run('TagListGenerator.py', options, async function (err, results) {
    //       if (err) throw err;
    //       await this.handleJSONUpload(results);
    //     });
    //   } catch (e) {
    //     this.$toast.error(`Failed to import from .script: ${e.message}`);
    //     this.file = null;
    //   }
    // },
    readJSON(file: File) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = res => {
          if (!res || !res.target || !res.target.result) {
            reject();
          } else {
            const resJSON = JSON.parse(res.target.result as string);
            resolve(resJSON);
          }
        };
        reader.onerror = err => reject(err);
        reader.readAsText(file);
      });
    },

    async handleImport() {
      if(this.name === '') {this.$toast.error("Please add a name");}
      if(this.existingConfigNames.includes(this.name)) {this.$toast.error("Duplicate anonymization config names not allowed.");}

      // Payload will have empty values that get built off of
      let payload = {
        name: this.name,
        configData: this.configData,
        constants: this.constants,
        variables: this.variables,
      }

      try {
        await this.$axios.post(`anonymization-config/`, payload)
        this.name = '';
        this.file = null;
        this.$emit("added")
      } catch (e) {
        this.$toast.error(e.response.data.message);
      }
    }
  }
})
